import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';
import { env } from '@/config/env';

/**
 * The single, typed Supabase client for the whole app. `Database` is generated
 * from the live schema (`npm run gen:types`) so every query is type-checked
 * against real columns — no more guessing field names.
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The PKCE code is exchanged explicitly in AuthCallbackPage (and stray codes
    // are funneled there by OAuthCallbackCatcher), so we turn off the implicit
    // URL detection to avoid a double-exchange race on the single-use code.
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});

/** Convenience aliases for generated row/insert/update types. */
export type { Database } from '@/types/database.types';
